import {
    DELETE_TAX,
    EDIT_TAX,
   ADD_TAX,
    GET_TAX,
  } from "../../Types";
  const initialState = {
    tax: [],
  };
  
  function tax(state = initialState, action) {
    switch (action.type) {
      case ADD_TAX: {
        return {
          ...state,
          tax: [...state.tax, action.payload],
        };
      }
      case GET_TAX: {
           const allTax = action.payload;
           return { ...state, tax: allTax };
       
      }
      case EDIT_TAX: {
        console.log(action.payload)
           let udateTax = state.tax.map((item) =>
             item.tax_rate_id === action.payload.tax_rate_id
               ? action.payload
               : item
           );
           return {
             ...state,
             tax: udateTax,
           };
        
      }
      case DELETE_TAX: {
        const after_delete_tax = state.tax.filter(
          (tax) =>
            tax.tax_rate_id !== action.payload.tax_rate_id
        );
        return { ...state, tax: after_delete_tax };
       
      }
      default:
        return state;
    }
  }
  
  export default tax;
  